import { Truck } from "lucide-react";
import { CrudPage } from "../components/crud/CrudPage";
import { useOpciones } from "../hooks/useOpciones";
import { Badge } from "../components/ui/Badge";

const estados = ["PROGRAMADO", "EN_PROCESO", "COMPLETADO", "CANCELADO"].map((e) => ({ value: e, label: e.replace("_", " ") }));

export default function Domicilio() {
  const { opciones: clientes } = useOpciones("/clientes", (c) => c.nombre);
  const { opciones: mascotas } = useOpciones("/mascotas", (m) => m.nombre);
  const { opciones: veterinarios } = useOpciones("/usuarios", (u) => u.nombre, (u) => ["VETERINARIO", "ADMIN"].includes(u.rol));

  return (
    <CrudPage
      resource="/domicilio"
          seccion="domicilio"
      titulo="Servicio a domicilio"
          icono={<Truck size={20} />}
      descripcion="Visitas y consultas a domicilio."
      nombreSingular="servicio a domicilio"
      campos={[
        { name: "clienteId", label: "Cliente", type: "select", options: clientes, required: true },
        { name: "mascotaId", label: "Mascota", type: "select", options: mascotas, required: true },
        { name: "veterinarioId", label: "Veterinario", type: "select", options: veterinarios },
        { name: "direccion", label: "Dirección", required: true, colSpan2: true },
        { name: "fecha", label: "Fecha y hora", type: "datetime-local", required: true },
        { name: "estado", label: "Estado", type: "select", options: estados },
        { name: "motivo", label: "Motivo", type: "textarea", colSpan2: true },
        { name: "costo", label: "Costo", type: "number" },
      ]}
      columnas={[
        { key: "fecha", label: "Fecha", render: (r: any) => new Date(r.fecha).toLocaleString("es-MX") },
        { key: "mascota", label: "Mascota", render: (r: any) => r.mascota?.nombre },
        { key: "direccion", label: "Dirección" },
        { key: "estado", label: "Estado", render: (r: any) => <Badge color="azul">{r.estado}</Badge> },
      ]}
    />
  );
}
